import { render, staticRenderFns } from "./ApplicationCommentsPanel.vue?vue&type=template&id=1a9eadfa"
import script from "./ApplicationCommentsPanel.vue?vue&type=script&lang=js"
export * from "./ApplicationCommentsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports